<template>
  <div
    v-if="false"
    class="dt-rec"
  >
    <ul
      class="recommend"
      style="display: flex"
    >
      <li>
        <a
          :href="'/qlist/' + generateRandomNum() + '/'"
          uigs="bottom_hot_recommend"
          title="今日热点推荐"
        >
          今日热点推荐
        </a>
      </li>
      <li>
        <a
          :href="'/qlist/' + generateRandomNum() + '/'"
          uigs="bottom_hot_query"
          title="热搜词排行榜"
        > 热搜词排行榜 </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getSpver } from '../../common/js/util';

export default {
  computed: {
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'boolean' }) || false;
    },
  },
  methods: {
    generateRandomNum() {
      const QLIST_SIZE = 972;
      return Math.ceil(Math.random() * QLIST_SIZE);
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.dt-rec {
  border-top: 8px solid #f5f5f5;
}
.recommend {
  background-position: bottom;
  background-size: 100% 1px;
  background-repeat: no-repeat;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 44px;
  margin: 0 10px;
  border-bottom: 1px solid #ededed;

  li {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    color: #555555;
    font-size: 13px;
    text-align: center;
    line-height: 15px;
    border-right: 1px solid #ededed;

    a {
      display: block;
      color: #555555;
    }
  }
}
.recommend li:last-child {
  border: none;
}
</style>
